import { ITermStep, ITermAcceptance } from '../reducers/termsConfigReducer';
import ACTIONS_TYPES from '../../constants/types';

interface ISetTermsConfigActionPayload {
  active: boolean;
  steps: ITermStep[];
}

interface ISetTermsConfigAction {
  type: typeof ACTIONS_TYPES.SET_TERMS_CONFIG;
  payload: ISetTermsConfigActionPayload;
}

const setTermsConfigAction = (payload: ISetTermsConfigActionPayload): ISetTermsConfigAction => {
  return { type: ACTIONS_TYPES.SET_TERMS_CONFIG, payload };
};

interface IGoNextStepAction {
  type: typeof ACTIONS_TYPES.SET_TERMS_NEXT_STEP;
  payload: undefined;
}

const goNextStep = (): IGoNextStepAction => {
  return { type: ACTIONS_TYPES.SET_TERMS_NEXT_STEP, payload: undefined };
};

interface ISetTermsAcceptanceAction {
  type: typeof ACTIONS_TYPES.SET_TERMS_ACCEPTANCE;
  payload: ITermAcceptance[];
}

const setTermsAcceptance = (payload: ITermAcceptance[]): ISetTermsAcceptanceAction => {
  return { type: ACTIONS_TYPES.SET_TERMS_ACCEPTANCE, payload };
};

export type TermsConfigActionTypes =
  | ISetTermsConfigAction
  | IGoNextStepAction
  | ISetTermsAcceptanceAction;

export default { setTermsConfigAction, goNextStep, setTermsAcceptance };
